<template>
  <SectionPlan
    :items="callcenterPlans"
    :compareData="compareData"
    compareText="ویژگی‌های بسته‌ها"
  />
</template>

<script setup>
import { useSlots } from "vue";
import { callcenterPlans } from "@/data/plans";

const slots = useSlots();

const compareData = {
  id: 1,
  title: "ویژگی‌های بسته‌های مرکز تماس ابری",
  subTitle: "ویژگی های اصلی",
  packagenames: {
    boronz: "بسته کریپتون",
    noghre: "بسته کادمیوم",
    talaei: "بسته بیسموت",
    opal: "بسته تنگستن",
  },
  listPack: [
    {
      id: 1,
      title: " فضای ابری (گیگ)",
      boronz: "20",
      noghre: "35",
      talaei: "50",
      opal: "65",
    },
    {
      id: 1,
      title: "تعداد کاربر",
      boronz: "50",
      noghre: "100",
      talaei: "150",
      opal: "200",
    },
    // {
    //   id: 2,
    //   title: "همزمانی تماس (بوق آزاد)",
    //   boronz: "5",
    //   noghre: "10",
    //   talaei: "15",
    //   opal: "20",
    // },
  ],
  options: [
    {
      id: 3,
      title: "سافت فون اختصاصی",
      // mobile_title: "چت سازمانی",
      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 4,
      title: "داشبورد مدیریتی",
      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 5,
      title: "پیامگیر صوتی",
      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 6,
      title: "نظرسنجی",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 7,
      title: "تیکتینگ",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 8,
      title: "گزارش پیشرفته",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 9,
      title: "گزارش پراکندگی",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 10,
      title: "تعیین سطوح دسترسی",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 11,
      title: "لیست سیاه و سفید",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 12,
      title: "مانیتورینگ زنده تماس‌ها",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 13,
      title: "کنترل زنده تماس‌ها",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 18,
      title: "نجوا",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 14,
      title: "والبورد",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 16,
      title: "چت آنلاین (وبچت)",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 17,
      title: "قابلیت اتصال به آی پی فون",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 15,
      title: "فکس ابری",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 19,
      title: "تماس مجدد با آخرین اپراتور",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
  ],
};
</script>
